module.exports = __webpack_public_path__ + "images/young-entrepreneur-411fde.png";